import axiosCall from './interceptor';
import URL from '../helper';

export const getAllLanguage = async () => {
  const url = `${URL.BASE_URL}language`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const getAllSupportedLanguages = async () => {
  const url = `${URL.BASE_URL}supportedlanguage`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const addLanguage = async payload => {
  const url = `${URL.BASE_URL}language`;
  let response = await axiosCall('post', url, payload);
  return response.data;
};

export const getTranslatekey = async () => {
  const url = `${URL.BASE_URL}settings/translatekey`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const updateTranslatekey = async payload => {
  const url = `${URL.BASE_URL}settings/translatekey`;
  let response = await axiosCall('post', url, payload);
  return response.data;
};

export const updateLanguagePreference = async language => {
  const url = `${URL.BASE_URL}updateLanguagePreference?languageCode=${language}`;
  let response = await axiosCall('patch', url);
  return response.data;
};

export const updateLanguageTranslation = async payload => {
  const url = `${URL.BASE_URL}config/language`;
  let response = await axiosCall('put', url, payload);
  return response.data;
};

export const updateAiWriting = async payload => {
  const url = `${URL.BASE_URL}config/ai`;
  let response = await axiosCall('put', url, payload);
  return response.data;
};